<template>
  <section>
    <div class="modal-body">
      <div v-if="out_of_date">
        <div class="row div-message" >
          <div class="col-md-12">
            <i class="fa fa-calendar-times-o icon-out-of-date"></i>
          </div>
        </div>
        <div class="row div-message" >
          <div class="col-md-12 text-message">
            {{ 'system_out_of_date' | translate | capitalize }}
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row div-message" >
          <div class="col-md-12">
            <i class="fa fa-calendar-check-o icon-updated"></i>
          </div>
        </div>
        <div class="row div-message" >
          <div class="col-md-12 text-message">
            {{ 'system_updated' | translate | capitalize }}
          </div>
        </div>
      </div>
      <div v-if="out_of_date" class="row update-options">
        <!-- <div class="col-md-6">
          <button type="button" class="btn btn-primary btn-block" @click="updateFromFile" id="btn-cancel">
            {{ 'update_from_file' | translate | capitalize }}
          </button>
        </div> -->
        <div class="col-md-12">
          <button type="button" class="btn btn-primary btn-block" @click="updateFromCloud" id="btn-cancel">
            {{ 'update_from_cloud' | translate | capitalize }}
          </button>
        </div>
      </div>
      
    </div>
  
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" @click="resetForm" id="btn-cancel">
        {{ 'close' | translate | capitalize }}
      </button>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      out_of_date: false
    }
  },
  computed: {
    ...mapGetters({modal: 'getStatusUpdateModal'})
  },
  methods: {
    ...mapActions(['setStatusUpdateModal', 'updateSystemFromCloud', 'restartWebServer']),
    resetForm () {
      window.$('#update_modal').modal('hide')
      this.setStatusUpdateModal(false)
    },
    updateFromCloud () {
      this.$spinner.show()
      this.updateSystemFromCloud()
        .then((res) => {
          console.log(res)
          this.$spinner.remove()
          this.$toast('successful_update')
          this.restartWebServer()
          this.resetForm()
        })
        .catch((err) => {
          this.$spinner.remove()
          this.$toast('update_error', 4)
          console.log(err)
        })
    },
    updateFromFile () {
      // aa
    }
  },
  created () {
    const self = this
    this.$store.dispatch('postValidateActivation')
      .then((res) => {
        if (res.data.out_of_version) {
          self.out_of_date = res.data.out_of_version
        }
      })
  }
}
</script>

<style scoped>
.icon-updated {
  font-size: 10em !important;
  color: #34BF49 !important;
}

.icon-out-of-date {
  font-size: 10em !important;
  color: #D73925 !important;
}

.div-message {
  text-align: center !important;
  margin-top: 10px !important;
}

.text-message {
  font-size: 18px;
}

.update-options {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// Update.vue